import * as S from '@effect/schema/Schema';
export const ParticleId = S.String.pipe(S.brand('@fixtuur/backpack/Api/ParticleId'));
